import config from '@/assets/js/config/Config'

import Luts from '@/assets/js/Luts';
import GPU from '@/assets/js/GPU';
import AppUI from '@/assets/js/UI';
import Lutify from '@/assets/js/Lutify';
import Blocks from '@/assets/js/Blocks';
import LutsPreview from "@/assets/js/LutsPreview";
import FileLoader from "@/assets/js/FileLoader";

import ContrastV2 from '@/assets/js/blocks/ContrastV2'
import ExposureV2 from "@/assets/js/blocks/ExposureV2";
import WhiteBalance from "@/assets/js/blocks/whiteBalance";
import LUTcontrol from "@/assets/js/blocks/LUTcontrol";
import CustomLUT from "@/assets/js/blocks/customLUT";

import {
	blocksStore,
	candidatesStore,
	defaultsStore,
	imagesStateStore,
	imagesStore,
	INDEXED_DB_VERSION_LUT_CONTROLS,
	INDEXED_DB_VERSION_LUT_SLIDERS,
	INDEXED_DB_VERSION_SYSTEM_LUTS,
	customLutsStore,
	LUTcontrolsStore,
	LUTslidersStore,
	systemLutsStore,
	versionStore,
	UserStore
} from "@/services/indexedDB.service";

// IDB SERVICE
window.versionStore = versionStore;
window.UserStore = UserStore;
window.LUTcontrolsStore = LUTcontrolsStore;
window.LUTslidersStore = LUTslidersStore;
window.systemLutsStore = systemLutsStore;
window.imagesStore = imagesStore;
window.candidatesStore = candidatesStore;
window.imagesStateStore = imagesStateStore;
window.customLutsStore = customLutsStore;
window.blocksStore = blocksStore;
window.defaultsStore = defaultsStore;

// NOTE:  a weird localforage bug where if the table is not alrady crated in IDB we would get error in app when using it:
// TypeError: Cannot set property 'db' of null
window.versionStore.createInstance().getItem(null);
window.imagesStore.createInstance().getItem(null);
window.candidatesStore.createInstance().getItem(null);
window.imagesStateStore.createInstance().getItem(null);
window.blocksStore.createInstance().getItem(null);
window.defaultsStore.createInstance().getItem(null);

LUTcontrolsStore.createInstance().ready(async () => {
	let version = await versionStore.getItem('LUTControls');
	if (!version || version < INDEXED_DB_VERSION_LUT_CONTROLS) {
		LUTcontrolsStore.clear();
		versionStore.setItem('LUTControls', INDEXED_DB_VERSION_LUT_CONTROLS);
	}
})

LUTslidersStore.createInstance().ready(async () => {
	let version = await versionStore.getItem('LUTSliders');
	if (!version || version < INDEXED_DB_VERSION_LUT_SLIDERS) {
		LUTslidersStore.clear();
		versionStore.setItem('LUTSliders', INDEXED_DB_VERSION_LUT_SLIDERS);
	}
})

systemLutsStore.createInstance().ready(async () => {
	let version = await versionStore.getItem('SystemLUTs');
	if (!version || version < INDEXED_DB_VERSION_SYSTEM_LUTS) {
		systemLutsStore.clear();
		versionStore.setItem('SystemLUTs', INDEXED_DB_VERSION_SYSTEM_LUTS);
	}
})


// CORE SERVICES
var UI, gpu, luts, lutify, blocks, lutPreviewer, loader, _Adjustments;

gpu = new GPU();
UI = new AppUI();
luts = new Luts();
lutify = new Lutify();
blocks = new Blocks();
lutPreviewer = new LutsPreview();
loader = new FileLoader();
_Adjustments = {
	ContrastV2: new ContrastV2(),
	ExposureV2: new ExposureV2(),
	WhiteBalance: new WhiteBalance(),
	LUTcontrols: new LUTcontrol(),
	customLUT: new CustomLUT(),
};

window.UI = UI;
window.gpu = gpu;
window.luts = luts;
window.lutify = lutify;
window.blocks = blocks;
window.lutPreviewer = lutPreviewer;
window.loader = loader;
window.lutPreviewer = lutPreviewer;
window._Adjustments = _Adjustments;

// Starting the app...
luts.fetchAll();
UI.initEvents();

export { UI, lutify, gpu, luts, blocks, loader };


